import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const SmoothImage = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  const [shouldSmoothImage, setShouldSmoothImage] = useState(!config.pixelated);
  return (
    <div className="flex items-center justify-between">
      <SettingTitle
        title="Smooth image"
        description="Improve visibility of image"
        configField="pixelated"
        unsetConfigField={() => unsetConfigField('pixelated')}
      />
      <Switch.Root
        aria-label="Toggle smooth image"
        data-test="smooth-image-switch"
        checked={shouldSmoothImage}
        onCheckedChange={newValue => {
          setShouldSmoothImage(newValue);
          updateConfig({pixelated: !newValue});
        }}>
        <Switch.Thumb checked={shouldSmoothImage} />
      </Switch.Root>
    </div>
  );
};
